import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { UpdateBusinessHoursRequest, ServiceVendorId, ServiceVendorBusinessHoursId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, businessHoursKeys, toast } from '@petseo/shared';

interface UpdateBusinessHoursParams {
  serviceVendorId: ServiceVendorId;
  businessHoursId: ServiceVendorBusinessHoursId;
  data: UpdateBusinessHoursRequest;
}

export const useUpdateBusinessHours = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ serviceVendorId, businessHoursId, data }: UpdateBusinessHoursParams) => {
      const response = await serviceVendorsClient.putBusinessHoursEndpoint(data, String(serviceVendorId), String(businessHoursId));
      return response.data;
    },
    onSuccess: (_, { serviceVendorId }) => {
      queryClient.invalidateQueries({ queryKey: businessHoursKeys.forVendor(serviceVendorId) });
      toast.success(TOAST_MESSAGES.BUSINESS_HOURS_UPDATED);
    },
    onError: () => toast.error(TOAST_MESSAGES.BUSINESS_HOURS_UPDATE_ERROR),
  });
};
